import gql from 'graphql-tag';

export const UPDATE_DEAL_BUILDER_QUOTE = gql`
  mutation UpdateDealBuilderQuote($input: UpdateQuoteInput!, $quoteId: ID!) {
    dealBuilder {
      updateDealBuilderQuote(input: $input, quoteId: $quoteId) {
        success
        error
      }
    }
  }
`;
